import { ReactElement, useMemo } from 'react';
import type { Locale } from 'date-fns';
import { translate } from '@micro-apps/env';
import { useCAWContext } from '../CAW';
import { format } from 'date-fns/format';
import { getUpdatedTimeLabel } from '../../calendar';
import Button from '../../button';

type Props = {
	onClose: () => unknown;
};

const displayUpdated = (date: string | undefined, locale?: Locale) => {
	const timeLabel = getUpdatedTimeLabel(date, translate, locale);
	if (!timeLabel) {
		return null;
	}

	return (
		<div className="Calendar-done-updated w-full">
			<span className="text-caption">{timeLabel}</span>
		</div>
	);
};

export default function CalendarDone({ onClose }: Props): ReactElement<any> {
	const { planStore, isDesktop, locale, dateFnsLocale } = useCAWContext();
	const lastUpdated = useMemo(
		() => planStore?.calendarResult?.lastUpdated,
		[planStore?.calendarResult]
	);
	const checkin = planStore?.search?.checkinDate;
	const checkout = planStore?.search?.checkoutDate;

	return (
		<div className="Calendar-Done Calendar-Done--active">
			<div className="Calendar-Done-inner flex flex-row spacing-inline-m items-center justify-end">
				{isDesktop && displayUpdated(lastUpdated, dateFnsLocale?.localeMappings[locale || 'en'])}
				<div className="Calendar-done-date-range">
					{checkin && checkout && (
						<span className="text-label text-nowrap">
							{format(checkin, 'P', { locale: dateFnsLocale?.localeMappings[locale || 'en'] })} -{' '}
							{format(checkout, 'P', { locale: dateFnsLocale?.localeMappings[locale || 'en'] })}{' '}
							{planStore?.search.flexDatesSelected
								? ` | ±${planStore?.search.flexDatesSelected} ${translate('days')}`
								: undefined}
						</span>
					)}
				</div>
				<Button
					intent="filled"
					className="flexdates-done-button w-full max-w-[125px]"
					disabled={!checkin || !checkout}
					onClick={onClose}
					onKeyDown={e => {
						if (e.key === 'Tab') {
							e.preventDefault();
							onClose();
						}
					}}
				>
					{translate('Apply')}
				</Button>
			</div>
		</div>
	);
}
